import { createTokenAccounts } from '../analyzeSolanaTransaction/createTokenAccounts'
import type { JsonDatasource } from '../analyzeSolanaTransaction/types'
import type { TransactionDetail } from '../schemas/transactionDetail'
import type { TokenTransfer } from '../schemas/transfer'
import type { SplTokenDatasource } from '../splTokenDatasource'
import { createTokenTransfers } from './createTokenTransfers'

type AddTransfersToSolanaTransactionParameters = {
  readonly transaction: TransactionDetail
  readonly tokenAccountOwnerMap: { [account: string]: string | undefined }
  readonly splTokenDatasource: SplTokenDatasource
  readonly jsonDatasource: JsonDatasource
  readonly accountIds: readonly string[]
}

export type TransactionWithTransfers = TransactionDetail & {
  readonly solTransfers: readonly TokenTransfer[]
  readonly tokenTransfersFromBalances: readonly TokenTransfer[]
  readonly tokenTransfersFromInstructions: readonly TokenTransfer[]
}

export const addTransfersToTransaction = async ({
  transaction,
  splTokenDatasource,
}: AddTransfersToSolanaTransactionParameters): Promise<TransactionWithTransfers> => {
  // Create token account list
  const tokenAccounts = createTokenAccounts(transaction)

  // splToken list を事前にまとめて取得 (tokenAccounts から mint アドレスを取得)
  const mut_splTokens = []
  const mintAddressSet = new Set(
    Object.values(tokenAccounts)
      .map((account) => account?.mint)
      .filter((mint): mint is string => mint !== undefined),
  )
  for (const mintAddress of mintAddressSet) {
    const splToken = await splTokenDatasource.getTokenByMintAccount(mintAddress)
    if (splToken !== undefined) {
      mut_splTokens.push(splToken)
    }
  }
  const splTokens = mut_splTokens

  // Create token transfer list using client/createTokenTransfers
  const {
    solTransfers,
    tokenTransfersFromBalances,
    tokenTransfersFromInstructions,
  } =
    transaction.meta?.err === null
      ? createTokenTransfers({ transaction, tokenAccounts, splTokens })
      : {
          solTransfers: [],
          tokenTransfersFromBalances: [],
          tokenTransfersFromInstructions: [],
        }

  return {
    ...transaction,
    solTransfers,
    tokenTransfersFromBalances,
    tokenTransfersFromInstructions,
  }
}
